import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import Contracts from "../../components/Modals/Contract/Contracts";
import EditContract from "../../components/Modals/Contract/EditContract";
import InvoiceStatusCell from "./InvoiceStatusCell";
import { MaterialReactTable } from "material-react-table";
import ClosedCandidates from "../../components/Modals/ClosedCandidates";
import { currency_converter_inr } from "../../utils/currencyUtils";
import { handleDeleteWithConfirm, contact_details} from "../../utils/sweetalert";
import toastr from "../../utils/toast";
import { formatDate } from "../../utils/format_dates";
import EditClient from "./editClient";
import { decodeHtml } from "../../utils/decodeHtml";
import ChartRenderer from "../../components/Charts/ChartRenderer";
import { useFinancialYears } from "../../utils/financial_year";
import SetContractOption from "../../components/Modals/Contract/SetContractOption";
import UploadContract from "../../components/Modals/Contract/UploadContract";
import AddContract from "../../components/Modals/Contract/AddContract";
import AddContact from "../../components/Modals/Orders/AddContact";
import MeetingForm from "../../components/Modals/Client/MeetingForm";
import { openInAppTab } from "../../utils/tabNavigation";
import useSmartBack from "../../hooks/useSmartBack";

function View() {
  const { id } = useParams();
  const navigate = useNavigate();
  const handleBack = useSmartBack("/client/list");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [client, setclient] = useState("");
  const [bd, setbd] = useState(null);
  const [cm, setcm] = useState(null);
  const [nopouch, setnopouch] = useState(null);
  const [contracts, setcontracts] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [options, setOptions] = useState([]);
  const [state, setStata] = useState([]);
  const [invoices, setinvoices] = useState([]);
  const [media, setmedia] = useState([]);
  const [family, setFamily] = useState([]);
  const [relation, setRelation] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [seniority, setSeniority] = useState(null);
  const [EditModel, setEditModel] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0, // MRT uses 0-based index
    pageSize: 50, // Match API pageLengt
  });
  const [executives, setExecutives] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [executiveCounts, setExecutiveCounts] = useState({ cs: null, vp: null, dir: null,});
  const [contractShowModel, setContractShowModel] = useState(false);
  const [IsEditModalOpen, setIsEditModalOpen] = useState(false);
  const [closedCandidatesModalShow, setClosedCandidatesModalShow] = useState(false);
  const [setContractOptionModel, setSetContractOptionModel] = useState(false);
  const [UploadModel, setUploadModel] = useState(false);
  const [Model, setModel] = useState(false);
  const [contractid, setcontractid] = useState(null);
  const [uploadContractData, setUploadContractData] = useState([]);
  const [newContractId, setNewContractId] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [RelationId, setRelationId] = useState(null);

  async function get_client_details() {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/get_client_details/`,
        { id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const nopoachclause = await axios.post(
        `${API_BASE_URL}/clients/get_client_nopoachclause/`,
        { id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const contracts = await axios.post(
        `${API_BASE_URL}/clients/get_contracts/`,
        { id: id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setclient(response.data[0]);
      setcontracts(contracts.data.contracts);
      setSelectedCompanyId(response.data[0].company_id);
      if (nopoachclause.data.name_string != "") {
        setnopouch(nopoachclause.data.name_string);
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
      if (error.response?.status === 403) {
      toastr.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "You do not have permission to view this client"
      );

      navigate("/client/list");
      return;
    }

    toastr.error("Failed to load client details");
    } finally {
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    setGlobalLoading(true);

    get_client_details();
  }, [id]);

  useEffect(() => {
    if (client && client.businessDeveloped_id && client.clientManaged_id) {
      async function fetchBdName() {
        const name = await get_username(client.businessDeveloped_id);
        setbd(name);
      }

      async function fetchCmName() {
        const name = await get_username(client.clientManaged_id);
        setcm(name);
      }

      fetchBdName();
      fetchCmName();
    }
  }, [client]);

  async function get_username(id) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/common_controller/get_user_name`,
        { id: id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const name =
        response.data.option.firstname + " " + response.data.option.lastname;
      return name;
    } catch (error) {
      console.log(error);
    }
  }

  const getValidUrl = (url) => {
    if (!url) return "#";
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  const handleOpenModal = (e, id) => {
    e.preventDefault();
    setSelectedContractId(id);
    setContractShowModel(true);
  };

  const showroles = (e, id) => {
    e.preventDefault();
    setGlobalLoading(true);
    async function get_roles() {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/clients/get_client_roles`,
          { id: id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setOptions(response.data.roles);
        const state = [
          {
            active: response.data.active,
            closed: response.data.closed,
            inactive: response.data.inactive,
            total: response.data.total,
          },
        ];
        setStata(state[0]);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    }

    get_roles();
  };

  const columns = [
    {
      accessorKey: "reference",
      header: "Role Id",
      size: 100,
      Cell: ({ row }) => {
        return (
          <Link to={`/role/view/${row.original.id}`}>
            <b>{row.original.reference}</b>
          </Link>
        );
      },
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 3,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
    },
    {
      accessorKey: "role_name",
      header: "Name",
      size: 200,
      Cell: ({ cell }) => decodeHtml(cell.getValue()),
    },
    {
      accessorKey: "client_name",
      header: "Client",
      size: 100,
    },
    {
      accessorKey: "agn",
      header: "AGN",
      size: 100,
    },
    {
      accessorKey: "Invoice",
      header: "Status",
      size: 100,
      Cell: ({ row }) => {
        return (
          <span>
            {/* Raised <br /> */}
            <InvoiceStatusCell role_id={row.original.id} />
          </span>
        );
      },
    },
    {
      accessorKey: "client_type",
      header: "Type",
      size: 100,
    },
    {
      accessorKey: "role_manager",
      header: "Role Manager",
      size: 100,
    },
    {
      accessorKey: "created_by",
      header: `Assigned To`,
      size: 100,
    },
    {
      accessorKey: "position_number",
      header: `Position`,
      size: 100,
    },
    {
      accessorKey: "ageing",
      header: `Aging`,
      size: 100,
    },
    {
      accessorKey: "role_status",
      header: "Status",
      size: 70,
    },
    {
      accessorKey: "country_name",
      header: "Country",
      size: 100,
    },
    {
      accessorKey: "industrymaster",
      header: "Major Industry",
      size: 100,
    },
    {
      accessorKey: "industry_minor",
      header: "Industry",
      size: 100,
    },
    {
      accessorKey: "dutymaster",
      header: "Function",
      size: 100,
    },
  ];

  const showinvoices = async (e, id) => {
    e.preventDefault();
    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/invoices/get_role_invoices/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setinvoices(response.data.invoices || []);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const invoiceColumn = [
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 100,
    },
    {
      accessorKey: "detail",
      header: "Detail",
      size: 70,
       Cell: ({ row }) => {
        return (
          <Link
            to={`/order/view/${row.original.invoice_id}`}
          >
            <b>{row.original.detail}</b>
          </Link>
        );
      },
    },
    {
      accessorKey: "itemstatus",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "conversion_rate",
      header: "Conversion Rate",
      size: 100,
    },
    {
      accessorKey: "amount",
      header: "Amount",
      size: 100,
      Cell: ({ row }) => currency_converter_inr(row.original.amount),
    },
    {
      accessorKey: "original_amount",
      header: "Original Amount",
      size: 100,
      Cell: ({ row }) => {
        return `${row.original.symbol} ${row.original.original_amount}`;
      },
    },
    {
      accessorKey: "invoice_number",
      header: "Invoice No",
      size: 100,
    },

    {
      accessorKey: "raised_date",
      header: `Raised Date`,
      size: 100,
    },
    {
      accessorKey: "issue_date",
      header: `Issue Date`,
      size: 100,
    },
    {
      accessorKey: "role_manager",
      header: `Role Manager`,
      size: 100,
    },
    {
      accessorKey: "assigned_to",
      header: `Assigned To`,
      size: 100,
    },
    {
      accessorKey: "candidate_name",
      header: "Candidate",
      size: 100,
    },
  ];

  const getDocuments = async (e, id) => {
    e.preventDefault();
    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/get_client_media/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setmedia(response.data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    const table = $("table.datatable").DataTable({
      autoWidth: false,
      fixedHeader: true,
      scrollX: true,
      columnDefs: [
        { width: "100px", targets: 0 }, // 0 = first column
      ],
    });

    return () => {
      table.destroy();
    };
  }, [media]);

  const showFamily = async (e, id) => {
    e.preventDefault();

    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/getfamily/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFamily(response.data.family);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const showRelation = (e = false, id) => {
    if (e) {
      e.preventDefault();
    }
    setGlobalLoading(true);
    get_relationships(id);
  };

  const get_relationships = async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/get_relationship/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRelation(response.data.relation);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const deleteRelation = async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/remove_relation/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastr.success(response.data.message);
      get_relationships(client?.company_id);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      showContacts(null, id);
    }
  }, [id]);

  const showContacts = async (e, id) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/get_contacts/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setContacts([...response.data.contacts]);
      // setContacts(response.data.contacts);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const DisableContact = async (id) => {
    setGlobalLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE_URL}/clients/disableContact/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.stat > 0) {
        setContacts((prev) => prev.filter((item) => item.id !== id));
        toastr.success("Contact Disabled");
      } else {
        toastr.error("Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  const OpenEditContractModal = async (e, id) => {
    console.log('edit contract:', id);
    setGlobalLoading(true);
    setSelectedContractId(id);
    setEditModel(true);
  };

  const showexecutives = async (e, id, seniority) => {
    e.preventDefault();
    setSeniority(seniority);
    setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
    setGlobalLoading(true);

    try {
      const rescount = await axios.post(
        `${API_BASE_URL}/lusha/get_executives_count`,
        { id: client?.company_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setExecutiveCounts({
        cs: rescount.data?.cstotalResults || 0,
        vp: rescount.data?.vptotalResults || 0,
        dir: rescount.data?.dirtotalResults || 0,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!seniority) return;
    fetchData();
  }, [seniority, pagination]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/lusha/get_executives/`,
        {
          id: client?.company_id,
          seniority: seniority,
          page: pagination.pageIndex,
          size: pagination.pageSize,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status == 200) {
        setRequestId(response.data.requestId);
        setExecutives(response.data.result);
        console.log(response.data.requestId);
        console.log(response.data.result);
        setRowCount(response.data.totalResults);
      } else if (response.status == 500) {
        toastr.error("Please Try Again");
      }
    } catch (error) {
      // 💬 API responded with an error (e.g. 400, 404, 500)
      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.error ||
          "Please Wait a few seconds and try again.";

        if (status === 400) {
          toastr.warning("Missing or invalid parameters");
        } else if (status === 404) {
          toastr.warning("Company domain not found");
        } else if (status === 504) {
          toastr.warning("Third-party API took too long, please retry");
        } else {
          toastr.error(message);
        }

        console.error("API Error:", status, message);
      }
      // 🚫 No response from server (e.g., backend down, CORS issue)
      else if (error.request) {
        toastr.error("No response from server. Check your network connection.");
        console.error(
          "Network request made but no response received:",
          error.request
        );
      }
      // 💥 Axios setup or other errors
      else {
        toastr.error("Request setup failed: " + error.message);
        console.error("Axios error:", error.message);
      }
    } finally {
      setGlobalLoading(false);
      setLoading(false);
    }
  };

  const excolumns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "jobTitle",
      header: "Designation",
    },
    {
      accessorKey: "contactId",
      header: "Action",
      Cell: ({ row }) => {
        return (
          <ul className="contact-icon d-flex align-items-center ">
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  fetchExContact("revealEmails", row.original.contactId);
                }}
                title="Reveal Email"
                className="p-1 rounded-circle contact-icon-mail d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="ti ti-mail text-gray-5"></i>
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  fetchExContact("revealPhones", row.original.contactId);
                }}
                title="Reveal Phone"
                className="p-1 rounded-circle contact-icon-call d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="ti ti-phone-call text-gray-5"></i>
                </span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  BuildRelation(row.original.contactId);
                }}
                title="Build Relation"
                className="p-1 rounded-circle contact-icon-msg d-flex align-items-center justify-content-center"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="fa-regular fa-handshake text-gray-5"></i>
                </span>
              </a>
            </li>
          </ul>
        );
      },
    },
  ];

  const fetchExContact = async (para, contactId) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/lusha/fetch_contact_details`,
        {
          requestId: requestId,
          contactIds: contactId,
          parameter: para,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      const data = response.data?.lushares;
      if (data) {
        const emails =
          data?.emailAddresses.map((item) => item.email).join(", ") || "";
        const phone =
          response.data?.lushares.phoneNumbers
            .map((item) => item.number)
            .join(", ") || "";
        if (para === "revealEmails" && emails != "") {
          contact_details({
            title: "Emails",
            text: emails,
            icon: "info",
            confirmButtonText: "Copy To ClipBoard",
            confirmCallback: () => CopyDetails(emails),
          });
        } else if (para === "revealPhones" && phone != "") {
          contact_details({
            title: "Phone Numbers",
            text: phone,
            icon: "info",
            confirmButtonText: "Copy To ClipBoard",
            confirmCallback: () => CopyDetails(phone),
          });
        } else {
          contact_details({
            title: "Opps!",
            text: "No Data Found",
            icon: "error",
            confirmButtonText: "Okay",
          });
        }
      } else {
        contact_details({
          title: "Opps!",
          text: "No Data Found",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      console.log(error);
      toastr.error(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const CopyDetails = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toastr.success("Copied to clipboard");
    } catch (error) {
      console.log(error);
      toastr.error(error);
    }
  };

  const BuildRelation = async (contactId) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/lusha/prospecting_contact_enrich`,
        {
          requestId: requestId,
          contactIds: contactId,
          parameter: "revealEmails",
          clientId: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const message = response.data.message;
      const candidate_id = response.data.candidate_id;

      toastr.success(message);

      document.getElementById("buildRelationTab")?.click();

      // contact_details({
      //   title: "",
      //   text: message,
      //   icon: "info",
      //   confirmButtonText: "View Candidate",
      //   confirmCallback: () => ViewCandidate(candidate_id),
      // });
    } catch (error) {
      console.log(error.response);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const ViewCandidate = async (candidate_id) => {
    const url = `/candidates/view/${candidate_id}`;
    openInAppTab(url);
  };

  const [selectedYear, setSelectedYear] = useState("Till Today");
  const [data, setData] = useState({
    total: 0,
    received: 0,
    outstanding: 0,
    baddebts: 0,
    yetToRaise: 0,
    issued: 0,
  });
  const years = useFinancialYears(6);

  const handleYearChange = async (year) => {
    setSelectedYear(year || "Till Today");
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/get_revenue_year_data`,
        { company_id: id, year }, // send company ID and year
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching year data:", error);
    }
  };

  useEffect(() => {
    handleYearChange(null); // null = Till Today
  }, []);

  const removeUploadedContract = async (id) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/contracts/delete_contract_file/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        navigate("/contract/list");
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="row">
          <div className="my-auto">
            <button
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
              style={{ cursor: "pointer", float: "right" ,position: "relative", top: "-10px"}}
              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-1"></i>
              Back
            </button>
          </div>
          <div className="col-xl-4 theiaStickySidebar">
            <div className="card card-bg-1 ribbone-card">
              {nopouch ? (
                // <div className="ribbone ribbone-top-right text-danger">
                //   <span className="bg-gray">No Poach</span>
                // </div>
                <span className="bookmark-sideleft-ribbone-success-left">
                  <span>No Poach</span>
                </span>
              ) : (
                ""
              )}
              {client?.relationship_time <= 24 ? (
                // <div className="arrow-ribbone-left bg-secondary"></div>
                <span
                  style={{ marginTop: "2rem" }}
                  className="bookmark-sideleft-ribbone-purple-left"
                >
                  <span>NEW</span>
                </span>
              ) : (
                <span
                  style={{ marginTop: "2rem" }}
                  className="bookmark-sideleft-ribbone-purple-left"
                >
                  <span>Existing</span>
                </span>
                // <div className="arrow-ribbone-left bg-secondary">Existing</div>
              )}
              <div className="card-body p-0">
                <span className="avatar avatar-xl m-auto d-flex mb-2 my-custom-client-logo-box">
                  <img
                    src={`${PINE_BASE_URL}/files/companyLogo/${
                      client.logo ?? "nologo.png"
                    }`}
                    className="client-logo"
                    alt="Img"
                    style={{
                      height: "100% !important",
                    }}
                  />
                </span>
                <div className="text-center px-3 pb-3 border-bottom">
                  <div className="mb-3">
                    <h5 className="d-flex align-items-center justify-content-center mb-1">
                      {decodeHtml(client.company_name)}
                      <i className="ti ti-discount-check-filled text-success ms-1"></i>
                    </h5>
                    <span className="text-danger justify-content-center fs-12 d-flex align-items-center me-1">
                      <i
                        style={{ fontSize: "15px" }}
                        className="ti ti-calendar me-1"
                      ></i>
                      {`${client?.relationship_time || 0} Months Old`}
                    </span>
                  </div>
                </div>
                <div className="p-3 border-bottom">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h6 className="fs-12">Basic Details</h6>
                    <a
                      href="#"
                      className="btn btn-icon btn-sm"
                      onClick={(e) => {
                        e.preventDefault();
                        setGlobalLoading(true);
                        setIsEditModalOpen(true);
                      }}
                    >
                      <i className="ti ti-edit"></i>
                    </a>
                    {IsEditModalOpen && (
                      <EditClient
                        onClose={() => {
                          setIsEditModalOpen(false);
                          window.location.reload();
                        }}
                        clientId={id}
                      />
                    )}
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="d-inline-flex align-items-center">
                      <i className="ti ti-phone me-2"></i>
                      Client Type
                    </span>
                    <p className="text-dark">{client.client_type}</p>
                  </div>
                  {client.website ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-mail-check me-2"></i>
                        Website
                      </span>
                      <a
                        href={getValidUrl(client.website)}
                        className="text-info d-inline-flex align-items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {client.website}
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.parentgroup ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Group Name
                      </span>
                      <p className="text-dark text-end">{client.parentgroup}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.company_origin ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Origin
                      </span>
                      <p className="text-dark text-end">
                        {client.company_origin}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.industrymaster ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Industry
                      </span>
                      <p className="text-dark text-end">
                        <span
                          className="fs-12 badge bg-outline-light"
                          style={{ border: "none !important" }}
                        >
                          {client.industrymaster}
                        </span>
                        <span className="fs-11">{client.industryminor}</span>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.company_origin ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Business Developed By
                      </span>
                      <p className="text-dark text-end">{bd}</p>
                    </div>
                  ) : (
                    ""
                  )}

                  {client.clientManaged_id ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Client Managed By
                      </span>
                      <p className="text-dark text-end">{cm}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.private_equity ? (
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        Private Equity
                      </span>
                      <p className="text-end badge bg-outline-secondary">
                        {client.private_equity}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {client.gcc ? (
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-map-pin-check me-2"></i>
                        GCC
                      </span>
                      <p className="text-end badge bg-outline-secondary">
                        {client.gcc}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {nopouch ? (
                  <div className="p-3 border-bottom">
                    <h6 className="mb-3 fs-12">
                      No Poach Regions & Countries{" "}
                      {nopouch.split(",").at(-1)?.trim()}
                    </h6>
                    <div className="align-items-center">
                      {nopouch
                        .split(",")
                        .slice(0, -1)
                        .map((item, key) => (
                          <span
                            key={key}
                            className="badge badge-soft-success me-1 mb-2 fs-10"
                          >
                            {item}
                          </span>
                        ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-xxl-12 col-xl-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                      <h5 className="mb-2">Revenue Overview</h5>
                      <div className="dropdown mb-2">
                        <button
                          className="btn btn-white border btn-sm d-inline-flex align-items-center dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-calendar me-1"></i>
                          {selectedYear || "Till Today"}
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end p-2">
                          <li>
                            <button
                              className="dropdown-item rounded-1 text-primary fw-medium"
                              onClick={() => handleYearChange(null)} // pass null here
                            >
                              Till Today
                            </button>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          {years.map((year) => (
                            <li key={year}>
                              <button
                                className="dropdown-item rounded-1"
                                onClick={() => handleYearChange(year)}
                              >
                                {year}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo position-relative mb-2">
                        <ChartRenderer
                          type="semiDonut"
                          data={data}
                          height={200}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div>
              <div className="bg-white rounded">
                <ul
                  className="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap mb-4"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link active fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab2"
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab"
                    >
                      <i className="ti ti-box me-1"></i>
                      Contracts
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab3"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showroles(e, client?.company_id)}
                    >
                      <i className="ti ti-basket-code me-1"></i>
                      Roles
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab4"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showinvoices(e, client.company_id)}
                    >
                      <i className="ti ti-file-invoice me-1"></i>
                      Invoices
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab5"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showFamily(e, client?.company_id)}
                    >
                      <i className="fa-solid fa-people-roof me-1"></i>
                      Family Tree
                    </a>
                  </li>
                  <div className="col-md-12"></div>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab6"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => getDocuments(e, client.company_id)}
                    >
                      <i className="ti ti-folder-open me-1"></i>
                      Documents
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab7"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showContacts(e, client?.company_id)}
                    >
                      <i className="ti ti-folder-open me-1"></i>
                      Contacts
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab8"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showexecutives(e, client?.company_id, 9)}
                    >
                      <i className="ti ti-folder-open me-1"></i>
                      Executives
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-medium d-flex align-items-center justify-content-center fs-13"
                      href="#bottom-justified-tab9"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                      onClick={(e) => showRelation(e, client?.company_id)}
                      id="buildRelationTab"
                    >
                      <i className="fa-regular fa-handshake me-1"></i>
                      Build Relationships
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content custom-accordion-items client-accordion">
                <div
                  className="tab-pane active show"
                  id="bottom-justified-tab2"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingOne2">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center justify-content-between flex-fill">
                            <h5 className="mb-0">Contracts</h5>
                          </div>
                          <div className="d-flex">
                            <button
                              className="btn btn-sm btn-primary ms-auto"
                              title="Add Contract"
                              type="button"
                              onClick={() => setSetContractOptionModel(true)}
                            >
                              <i className="fa-solid fa-plus me-1"></i> Add
                              Contract
                            </button>
                          </div>
                          {setContractOptionModel && (
                            <SetContractOption
                              onClose={(data) => {
                                setSetContractOptionModel(false);
                                data.model == "upload" && setUploadModel(true);
                                data.model == "manually" && setModel(true);
                              }}
                            />
                          )}
                          {UploadModel && (
                            <UploadContract
                              onClose={(data) => {
                                setUploadModel(false);
                                setcontractid(data.contract_id);
                                setUploadContractData(data.response);
                                data.response != undefined && setModel(true);
                              }}
                            />
                          )}
                          {Model && (
                            <AddContract
                              onClose={(data) => {
                                setModel(false);
                                if (data != undefined) {
                                  setSelectedContractId(data.contract_id);
                                  setContractShowModel(true);
                                  setNewContractId(true);
                                } else {
                                  if (contractid != null) {
                                    removeUploadedContract(contractid);
                                    setUploadContractData([]);
                                    setcontractid(null);
                                  }
                                }
                              }}
                              updata={uploadContractData}
                              contract_id={contractid}
                            />
                          )}

                          {EditModel && (
                            <EditContract
                              id={selectedContractId}
                              onClose={() => {
                                setEditModel(false);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div
                        id="primaryBorderOne2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingOne2"
                      >
                        <div className="accordion-body pb-0">
                          <div className="row">
                            {contracts.length > 0 ? (
                              <table className="table table-responsive">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Contract Name</th>
                                    <th>AGN No</th>
                                    <th>Contract Signed</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {contracts.map((contract, index) => (
                                    <tr key={index}>
                                      <td>
                                        <a href="#" onClick={(e) => {e.preventDefault(); handleOpenModal(e, contract?.id);}} title="view contract">
                                          <i className="fa-solid fa-eye"></i>
                                        </a>
                                        <a href="#" onClick={(e) =>{e.preventDefault(); OpenEditContractModal(e, contract?.id);}} title="Edit Contract">
                                          <i className="fa-solid fa-pen ms-2"></i>
                                        </a>
                                      </td>
                                      <td style={{ textWrapMode: "wrap", textWrapStyle: "balance"}}>{contract?.contract_name}</td>
                                      <td>{contract?.agn}</td>
                                      <td>{contract?.contractsigned}</td>
                                      <td>{contract?.contract_status}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              "No Contracts Found"
                            )}
                            {contractShowModel && (
                              <Contracts
                                onClose={() => setContractShowModel(false)}
                                contractid={selectedContractId}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab3"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingTwo2">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center justify-content-between flex-fill">
                            <h5 className="mb-0">Roles</h5>
                          </div>
                          <div className="d-flex">
                            <button
                              className="btn btn-sm btn-primary ms-auto"
                              type="button"
                              onClick={(e) =>
                                navigate("/role/add_new")
                              }
                            >
                              <i className="fa-solid fa-plus me-1"></i> New Role
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="primaryBorderTwo2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingTwo2"
                      >
                        <div className="accordion-body">
                          <div className="row align-items-center g-3 mb-3">
                            <div className="col-sm-2">
                              <h6>Total : {state.total}</h6>
                            </div>
                            <div className="col-sm-2">
                              <h6>Active : {state.active}</h6>
                            </div>
                            <div className="col-sm-2">
                              <h6>Inactive : {state.inactive}</h6>
                            </div>
                            <div className="col-sm-2">
                              <h6>Closed : {state.closed}</h6>
                            </div>
                            {closedCandidatesModalShow && (
                              <ClosedCandidates
                                client_id={client?.company_id}
                                onClose={() =>
                                  setClosedCandidatesModalShow(false)
                                }
                              />
                            )}
                            {state.closed > 0 && (
                              <div className="col-sm-4">
                                <a
                                  href="#"
                                  className="btn btn-sm btn-info"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setGlobalLoading(true);
                                    setClosedCandidatesModalShow(true);
                                  }}
                                >
                                  Closed Candidates
                                </a>
                              </div>
                            )}
                          </div>
                          <MaterialReactTable
                            columns={columns}
                            data={options}
                            initialState={{
                              pagination: { pageSize: 10 },
                            }}
                            muiTableBodyRowProps={{
                              sx: {
                                height: "32px", // compact row height
                              },
                            }}
                            muiTableBodyCellProps={{
                              sx: {
                                padding: "4px 8px", // compact cell padding
                              },
                            }}
                            muiTableHeadCellProps={{
                              sx: {
                                padding: "4px 8px", // same as body cells
                                height: "32px", // or less
                              },
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab4"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingThree2">
                        <div
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          role="button"
                          data-bs-target="#primaryBorderThree2"
                          aria-expanded="true"
                          aria-controls="primaryBorderThree2"
                        >
                          <h5>Invoices</h5>
                        </div>
                      </div>
                      <div
                        id="primaryBorderThree2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingThree2"
                      >
                        <div className="accordion-body">
                          {invoices.length > 0 && (
                            <MaterialReactTable
                              columns={invoiceColumn}
                              data={invoices}
                              enableGrouping
                              initialState={{
                                grouping: ["role_name"], // group by role_name
                                expanded: true, // expand groups by default
                                pagination: { pageSize: 100 },
                              }}
                              muiTableBodyRowProps={{
                                sx: {
                                  height: "32px", // compact row height
                                },
                              }}
                              muiTableBodyCellProps={{
                                sx: {
                                  padding: "4px 8px", // compact cell padding
                                },
                              }}
                              muiTableHeadCellProps={{
                                sx: {
                                  padding: "4px 8px", // same as body cells
                                  height: "32px", // or less
                                },
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab5"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFour2">
                        <div
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          role="button"
                          data-bs-target="#primaryBorderFour2"
                          aria-expanded="true"
                          aria-controls="primaryBorderFour2"
                        >
                          <h5>Family Tree</h5>
                        </div>
                      </div>
                      <div
                        id="primaryBorderFour2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingFour2"
                      >
                        <div className="accordion-body">
                          <div
                            style={{ overflowX: "auto" }}
                            className="custom-datatable-filter table-responsive no-datatable-length border"
                          >
                            {family && family.length > 0 ? (
                              <table className="table family">
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "100px" }}>
                                      Company Id
                                    </th>
                                    <th>Company Name</th>
                                    <th>Private Equity</th>
                                    <th>BD By</th>
                                    <th>Industry (Major/Minor)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {family.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.reference}</td>
                                      <td>
                                        <div className="d-flex align-items-center file-name-icon">
                                          <a
                                            href={`/client/view/${item.id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${item.id}`); }}
                                            className="avatar avatar-md border rounded-circle"
                                            target="_blank"
                                          >
                                            <img
                                              src={
                                                item.logo
                                                  ? `${PINE_BASE_URL}/files/companyLogo/${item.logo}`
                                                  : `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                                              }
                                              className="img-fluid"
                                              alt="logo"
                                              style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          </a>
                                          <div className="ms-2">
                                            <h6 className="fw-medium mb-0">
                                              <a
                                                target="_blank"
                                                href={`/client/view/${item.id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${item.id}`); }}
                                              >
                                                {item.name}
                                              </a>
                                            </h6>
                                          </div>
                                        </div>
                                      </td>
                                      <td>{item.pe}</td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.bdpic}`}
                                              alt="Img"
                                              title={`${item.bd}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <p className="text-title mb-0">
                                          {item.industrymaster}
                                        </p>
                                        <span>{item.industry}</span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <b>No Data Found</b>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab6"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFive2">
                        <div
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          role="button"
                          data-bs-target="#primaryBorderFive2"
                          aria-expanded="true"
                          aria-controls="primaryBorderFive2"
                        >
                          <h5>Documents</h5>
                        </div>
                      </div>
                      <div
                        id="primaryBorderFive2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingFive2"
                      >
                        <div className="accordion-body">
                          <div
                            style={{ overflowX: "auto" }}
                            className="custom-datatable-filter table-responsive no-datatable-length border"
                          >
                            {media.media && media.media.length > 0 && (
                              <table className="table datatable">
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "100px" }}>Subject</th>
                                    <th>description</th>
                                    <th>Created</th>
                                    <th>Industry (Major/Minor)</th>
                                    <th>Upload By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {media.media.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center file-name-icon">
                                          <a
                                            href={`${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`}
                                            className="avatar avatar-md bg-light"
                                            target="_blank"
                                          >
                                            <i className="fa-solid fa-file"></i>
                                          </a>
                                          <div className="ms-2">
                                            <p className="text-title fw-medium  mb-0">
                                              <a
                                                href={`${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`}
                                                target="_blank"
                                              >
                                                {item.subject}
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      </td>
                                      <td>{item.description}</td>
                                      <td>{item.created}</td>
                                      <td>
                                        <p className="text-title mb-0">
                                          {item.industrymaster_name}
                                        </p>
                                        <span>{item.industry}</span>
                                      </td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                              alt="Img"
                                              title={`${item.username}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {media.media3.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center file-name-icon">
                                          <a
                                            href={`${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`}
                                            className="avatar avatar-md bg-light"
                                            target="_blank"
                                          >
                                            <i className="fa-solid fa-file"></i>
                                          </a>
                                          <div className="ms-2">
                                            <p className="text-title fw-medium  mb-0">
                                              <a
                                                target="_blank"
                                                href={`${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`}
                                              >
                                                {item.subject}
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      </td>
                                      <td>{item.description}</td>
                                      <td>{item.created}</td>
                                      <td>
                                        <p className="text-title mb-0">
                                          {item.industrymaster_name}
                                        </p>
                                        <span>{item.industry}</span>
                                      </td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                              alt="Img"
                                              title={`${item.username}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                            {media.kms_media && media.kms_media.length > 0 && (
                              <table className="table datatable">
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "10px !important" }}>
                                      Subject
                                    </th>
                                    <th style={{ width: "10px !important" }}>
                                      Description
                                    </th>
                                    <th>Created</th>
                                    <th>Document Type</th>
                                    <th>Industry (Major/Minor)</th>
                                    <th>Upload By</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {media.kms_media.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center file-name-icon">
                                          <a
                                            target="_blank"
                                            href={`${PINE_BASE_URL}/files/media/${item.filename}`}
                                            className="avatar avatar-md bg-light"
                                          >
                                            <i className="fa-solid fa-file"></i>
                                          </a>
                                          <div className="ms-2">
                                            <p className="text-title fw-medium  mb-0">
                                              <a
                                                target="_blank"
                                                href={`${PINE_BASE_URL}/files/media/${item.filename}`}
                                              >
                                                {item.subject}
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      </td>
                                      <td>{item.description}</td>
                                      <td>{item.Created}</td>
                                      <td>{item.Document_type}</td>
                                      <td>
                                        <p className="text-title mb-0">
                                          {item.industry_master}
                                        </p>
                                        <span>{item.minor_indutry}</span>
                                      </td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                              alt="Img"
                                              title={`${item.username}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                            {(media.media2 && media.media2.length > 0) ||
                              (media.media4 && media.media4.length > 0 && (
                                <table className="table datatable">
                                  <thead className="thead-light">
                                    <tr>
                                      <th>Name</th>
                                      <th>keywords</th>
                                      <th>Created</th>
                                      <th>Upload By</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {media.media2.map((item, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="d-flex align-items-center file-name-icon">
                                            <a
                                              href={
                                                item.file.startsWith(
                                                  "data:image"
                                                )
                                                  ? item.file
                                                  : `${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`
                                              }
                                              className="avatar avatar-md bg-light"
                                              target="_blank"
                                            >
                                              <i className="fa-solid fa-file"></i>
                                            </a>
                                            <div className="ms-2">
                                              <p className="text-title fw-medium  mb-0">
                                                <a
                                                  href={
                                                    item.file.startsWith(
                                                      "data:image"
                                                    )
                                                      ? item.file
                                                      : `${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`
                                                  }
                                                  target="_blank"
                                                >
                                                  {item.name}
                                                </a>
                                              </p>
                                            </div>
                                          </div>
                                        </td>
                                        <td>{item.keyword}</td>
                                        <td>{item.created}</td>
                                        <td>
                                          <div className="avatar-list-stacked avatar-group-sm">
                                            <span className="avatar avatar-rounded">
                                              <img
                                                className="border border-white"
                                                src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                                alt="Img"
                                                title={`${item.username}`}
                                              />
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                    {media.media4.map((item, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="d-flex align-items-center file-name-icon">
                                            <a
                                              href={
                                                item.file.startsWith(
                                                  "data:image"
                                                )
                                                  ? item.file
                                                  : `${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`
                                              }
                                              className="avatar avatar-md bg-light"
                                              target="_blank"
                                            >
                                              <i className="fa-solid fa-file"></i>
                                            </a>
                                            <div className="ms-2">
                                              <p className="text-title fw-medium  mb-0">
                                                <a
                                                  href={
                                                    item.file.startsWith(
                                                      "data:image"
                                                    )
                                                      ? item.file
                                                      : `${PINE_BASE_URL}/files/mediaBI/profile/${item.savename}`
                                                  }
                                                  target="_blank"
                                                >
                                                  {item.name}
                                                </a>
                                              </p>
                                            </div>
                                          </div>
                                        </td>
                                        <td>{item.keyword}</td>
                                        <td>{item.created}</td>
                                        <td>
                                          <div className="avatar-list-stacked avatar-group-sm">
                                            <span className="avatar avatar-rounded">
                                              <img
                                                className="border border-white"
                                                src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                                alt="Img"
                                                title={`${item.username}`}
                                              />
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab7"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFive2">
                        <div className="accordion-button">
                          <div className="d-flex align-items-center justify-content-between flex-fill">
                            <h5 className="mb-0">Contacts</h5>
                          </div>
                          <div className="d-flex">
                            <button
                              className="btn btn-sm btn-primary ms-auto"
                              type="button"
                              onClick={() => setShowAddContactModal(true)}
                            >
                              <i className="fa-solid fa-plus me-1"></i> New
                              Contact
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="primaryBorderFive2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingFive2"
                      >
                        <div className="accordion-body">
                          {showAddContactModal && (
                            <AddContact
                              show={showAddContactModal}
                              onClose={() => {
                                setShowAddContactModal(false);
                              }}
                              company_id={selectedCompanyId}
                              token={token}
                              onSuccess={async () => {
                                setShowAddContactModal(false);
                                await get_client_details();
                                await showContacts(null, id);
                              }}
                            />
                          )}
                          <div
                            style={{ overflowX: "auto" }}
                            className="custom-datatable-filter table-responsive no-datatable-length border"
                          >
                            {contacts && contacts.length > 0 ? (
                              <table className="table contacts">
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "100px" }}>Client</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Designation</th>
                                    <th>Client Manager</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {contacts.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.company_name}</td>
                                      <td>{item.client_name}</td>
                                      <td>{item.email ? item.email : "NA"}</td>
                                      <td>
                                        {item.phone && item.phone != 0
                                          ? item.phone
                                          : "NA"}
                                      </td>
                                      <td>
                                        {item.designation
                                          ? item.designation
                                          : "NA"}
                                      </td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.userpic}`}
                                              alt="Img"
                                              title={`${item.emp_name}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleDeleteWithConfirm({
                                              title: "Disable Contact",
                                              text: "This Contact will get disabled",
                                              icon: "warning",
                                              confirmButtonText:
                                                "Yes, Disable it",
                                              confirmCallback: () =>
                                                DisableContact(item.id),
                                            });
                                          }}
                                        >
                                          <i className="fa-solid fa-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <b>No Data Found</b>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab8"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFive2">
                        <div
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          role="button"
                          data-bs-target="#primaryBorderFive2"
                          aria-expanded="true"
                          aria-controls="primaryBorderFive2"
                        >
                          <h5>Executives</h5>
                        </div>
                      </div>
                      <div
                        id="primaryBorderFive2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingFive2"
                      >
                        <div className="accordion-body">
                          <div className="mb-1">
                            <button
                              type="button"
                              className={`btn btn-outline-primary rounded-pill ms-1 ${
                                seniority == 9 ? "active" : ""
                              }`}
                              onClick={() => {
                                setSeniority(9);
                              }}
                            >
                              C-Suite -{" "}
                              {executiveCounts.cs ? executiveCounts.cs : 0}
                            </button>
                            <button
                              type="button"
                              className={`btn btn-outline-secondary rounded-pill ms-1 ${
                                seniority == 8 ? "active" : ""
                              }`}
                              onClick={() => {
                                setSeniority(8);
                              }}
                            >
                              VPs -{" "}
                              {executiveCounts.vp ? executiveCounts.vp : 0}
                            </button>
                            <button
                              type="button"
                              className={`btn btn-outline-warning rounded-pill ms-1 ${
                                seniority == 6 ? "active" : ""
                              }`}
                              onClick={() => {
                                setSeniority(6);
                              }}
                            >
                              Directors -{" "}
                              {executiveCounts.dir ? executiveCounts.dir : 0}
                            </button>
                          </div>
                          <MaterialReactTable
                            columns={excolumns}
                            data={executives}
                            rowCount={rowCount}
                            manualPagination
                            onPaginationChange={setPagination}
                            state={{ pagination, isLoading: loading }}
                            enablePagination
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab9"
                  role="tabpanel"
                >
                  <div className="accordion accordions-items-seperate">
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFive2">
                        <div
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          role="button"
                          data-bs-target="#primaryBorderFive2"
                          aria-expanded="true"
                          aria-controls="primaryBorderFive2"
                        >
                          <h5>Build Relationships</h5>
                        </div>
                      </div>
                      <div
                        id="primaryBorderFive2"
                        className="accordion-collapse collapse show border-top"
                        aria-labelledby="headingFive2"
                      >
                        <div className="accordion-body">
                          <div
                            style={{ overflowX: "auto" }}
                            className="custom-datatable-filter table-responsive no-datatable-length border"
                          >
                            {relation && relation.length > 0 ? (
                              <table className="table relation">
                                <thead className="thead-light">
                                  <tr>
                                    <th style={{ width: "100px" }}>
                                      Candidate
                                    </th>
                                    <th>Added By</th>
                                    <th>Added On</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {relation.map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={`/candidates/view/${item?.candidate_id}`}
                                            target="_blank"
                                            className="avatar avatar-md border avatar-rounded"
                                            onClick={(event) => {
                                              event.preventDefault();
                                              openInAppTab(
                                                `/candidates/view/${item?.candidate_id}`,
                                              );
                                            }}
                                          >
                                            {item?.userpic ? (
                                              <img
                                                src={`${PINE_BASE_URL}/files/imageCandidate/${item?.userpic}`}
                                                className="img-fluid"
                                                alt="img"
                                              />
                                            ) : (
                                              <img
                                                src="https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"
                                                className="img-fluid"
                                                alt="img"
                                              />
                                            )}
                                          </Link>
                                          <div className="ms-2">
                                            <h6 className="fw-medium fs-12 mbm-12">
                                              <Link
                                                to={`/candidates/view/${item?.candidate_id}`}
                                                target="_blank"
                                                onClick={(event) => {
                                                  event.preventDefault();
                                                  openInAppTab(
                                                    `/candidates/view/${item?.candidate_id}`,
                                                  );
                                                }}
                                              >
                                                {item?.candidate_name}
                                              </Link>
                                            </h6>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="avatar-list-stacked avatar-group-sm">
                                          <span className="avatar avatar-rounded">
                                            <img
                                              className="border border-white"
                                              src={`${PINE_BASE_URL}/files/media/${item.emp_pic}`}
                                              alt="Img"
                                              title={`${item.user}`}
                                            />
                                          </span>
                                        </div>
                                      </td>
                                      <td>{formatDate(item.created)}</td>
                                      <td>
                                        {!item?.relation_id ? (
                                          <>
                                            <button
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setShowMeetingForm(true);
                                                setRelationId(
                                                  item?.build_relation_id
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                              className="btn btn-sm btn-primary"
                                            >
                                              Set Meeting
                                            </button>
                                          </>
                                        ) : (
                                          <>
                                            <i
                                              onClick={() => {
                                                setShowMeetingForm(true);
                                                setRelationId(
                                                  item?.build_relation_id
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                              className="fa-regular fa-pen-to-square text-default me-2"
                                            ></i>
                                            {item?.pending_meeting == 0 && (
                                              <i
                                                onClick={() => {
                                                  if (
                                                    window.confirm(
                                                      "Are you sure you want to remove this relation?"
                                                    )
                                                  ) {
                                                    deleteRelation(
                                                      item?.relation_id
                                                    );
                                                  }
                                                }}
                                                style={{ cursor: "pointer" }}
                                                title="Stop Schedule"
                                                className="fa-regular fa-trash-can text-danger"
                                              ></i>
                                            )}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <b>No Data Found</b>
                            )}
                            {showMeetingForm && (
                              <MeetingForm
                                onClose={() => {
                                  setShowMeetingForm(false);
                                  get_relationships(client?.company_id);
                                }}
                                relationId={RelationId}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default View;
